import { render } from "./TabsandTextcards.vue?vue&type=template&id=4bda2788&scoped=true"
import script from "./TabsandTextcards.vue?vue&type=script&lang=js"
export * from "./TabsandTextcards.vue?vue&type=script&lang=js"

import "./TabsandTextcards.vue?vue&type=style&index=0&id=4bda2788&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bda2788"]])

export default __exports__